export enum UserActionEnum {
    create = 'CREATE',
    update = 'UPDATE',
    delete = 'DELETE',
}
